export default interface VReservation {
  tenantId: number;
  reservationId: number;
  reservationAccUnitTypeId: number;
  bookingDate: string;
  distributionChannelType: string;
  distributionChannelTypeId?: number;
  otachannelName: string;
  otareservationId: string;
  arrivalDate: string;
  departureDate: string;
  numberOfNights: number;
  expectedArrivalTime: string;
  totalPrice: number;
  currencyCode: string;
  reservationHolderId: number;
  reservationHolderName: string;
  reservationHolderTelephoneNumber: string | null;
  reservationGuestName: string | null;
  reservationGuestPlaceholder: string | null;
  countryOfResidence: string;
  propertyId: number;
  propertyName: string;
  accomodationUnitTypeName: string;
  accomodationUnitName: string;
  numberOfAdults: number;
  numberOfChildren: number;
  modificationDate: string;
  cancelationDate: string;
  optionExpirationDate: string;
  statusId: number;
  statusName: string;
  propertyStaffRemarks: string;
  guestRemarks: string;
  remarksForOwner: string;
  generalMaintenanceStaffRemarks: string;
  unitMaintenanceStaffRemarks: string;
  otaChannelComission: number;
  ownerTotalPrice: number | 0;
  amountToInvoice: number;
  reservationInvoiceStatusTextResourceKey: string;
}

export interface DashboardReservationsAdditionalInfo {
  countOfReservations: number;
  countOfReservationUnits: number;
  totalPrice?: number;
  totalPriceOfConfirmed?: number;
}

export interface DashboardArrivalsDeparturesKPISummaryViewModel {
  totalReservations: number;
  upcomingReservations: number;
  completedReservations: number;
  totalReservationsUnits: number;
  upcomingReservationsUnits: number;
  completedReservationsUnits: number;
}

export const reservationStatuses = [
  {
    id: 1,
    color: "warning",
    icon: "fa-pause-circle",
    text: "t.ReservationStatus.Hold",
  },
  {
    id: 2,
    color: "success",
    icon: "fa-check-circle",
    text: "t.ReservationStatus.Confirmed",
  },
  {
    id: 3,
    color: "error",
    icon: "fa-ban",
    text: "t.ReservationStatus.Canceled",
  },
  {
    id: 4,
    color: "primary",
    icon: "fa-sign-in-alt",
    text: "t.ReservationStatus.CheckedIn",
  },
  {
    id: 5,
    color: "accent",
    icon: "fa-sign-out-alt",
    text: "t.ReservationStatus.CheckedOut",
  },
  {
    id: 6,
    color: "black",
    icon: "fa-map-marker-slash",
    text: "t.ReservationStatus.NoShow",
  },
];
